import React from "react";
import {
  UserRound, Users, Laptop2, Trophy, Dumbbell, Apple,
} from "lucide-react";
import { siteData } from "../mock";

const iconMap = { UserRound, Users, Laptop2, Trophy, Dumbbell, Apple };

export default function Services() {
  return (
    <section id="services" className="relative bg-purple-band py-24">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        {/* Section Label */}
        <div className="mb-2">
          <span className="deal-yellow font-heading font-semibold tracking-[0.3em] text-sm md:text-base">
            WHAT WE OFFER
          </span>
        </div>
        <h2 className="font-display text-white font-bold text-5xl md:text-7xl tracking-wide mb-14">
          SERVICES
        </h2>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {siteData.services.map((svc) => {
            const Icon = iconMap[svc.icon];
            return (
              <div
                key={svc.id}
                className="card-surface rounded-xl p-7 flex flex-col gap-5 hover-lift"
              >
                <div className="flex items-start gap-5">
                  <div className="shrink-0 w-16 h-16 rounded-lg bg-[#e10600] flex items-center justify-center">
                    {Icon && <Icon size={32} className="text-[#0a0a0a]" strokeWidth={2.2} />}
                  </div>
                  <h3 className="font-display font-bold text-white text-2xl md:text-[1.6rem] leading-tight whitespace-pre-line tracking-wide">
                    {svc.title}
                  </h3>
                </div>
                <div className="h-px w-full bg-[#e10600]/25" />
                <p className="text-white/80 leading-relaxed text-[15px]">
                  {svc.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
